import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { Footer, MobileNavbar, Navbar } from "./components";

export function AppShell({ children }: { children: ReactNode }) {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) {
    return <div className="min-h-screen bg-ink text-slate-200">{children}</div>;
  }

  return (
    <div className="min-h-screen bg-ink text-slate-200">
      <Navbar />
      {children}
      <Footer />
      <MobileNavbar />
    </div>
  );
}
